import { apiPost } from '../../utils/api';

/** Sites wizard HTTP API (DONE.md: no direct Firestore writes from the app). */
export const sitesApi = {
  importSite: (workspaceId, url) => apiPost('/sitesImport', { workspaceId, url }),
  listSites: (workspaceId) => apiPost('/sitesList', { workspaceId }),
  generateSite: (workspaceId, brief, seed, look) =>
    apiPost('/sitesGenerate', { workspaceId, brief, seed, look }),
  renderSite: (workspaceId, siteId, { look, variant, typePairingId, paletteId } = {}) =>
    apiPost('/sitesRender', { workspaceId, siteId, look, variant, typePairingId, paletteId }),
  updateSite: (workspaceId, siteId, patch) => apiPost('/sitesUpdate', { workspaceId, siteId, ...patch }),
  getEditorSite: (workspaceId, siteId) => apiPost('/sitesGetEditor', { workspaceId, siteId }),
  sendOwnershipCode: (workspaceId, siteId, email) =>
    apiPost('/sitesOwnership', { workspaceId, siteId, email }),
  verifyOwnershipCode: (workspaceId, siteId, code) =>
    apiPost('/sitesOwnership', { workspaceId, siteId, code }),
  connectDomain: (workspaceId, siteId, host) =>
    apiPost('/sitesDomainConnect', { workspaceId, siteId, host }),
  checkDomain: (workspaceId, siteId) =>
    apiPost('/sitesDomainConnect', { workspaceId, siteId, check: true }),
  publishSite: (workspaceId, siteId, extra = {}) =>
    apiPost('/sitesPublish', { workspaceId, siteId, ...extra }),
  mediaAction: (workspaceId, siteId, action, extra = {}) =>
    apiPost('/sitesMedia', { workspaceId, siteId, action, ...extra }),
};
